import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import { HiArrowUpRight } from 'react-icons/hi2';
import Reveal from '../../../shared/Reveal/Reveal';
import { useInsightsFeaturedContent } from '../../../../hooks/useInsightsFeaturedContent';
import featuredImage from '../../../../assets/images/insights/featured/main.jpg';
import './Featured.css';

const Featured = () => {
  const { content, isLoading } = useInsightsFeaturedContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, cta, card, image } = content;

  return (
    <section className="insights-featured">
      <div className="insights-featured__inner">
        <Reveal className="insights-featured__header">
          <div className="insights-featured__heading">
            {eyebrow ? <p className="insights-featured__eyebrow">{eyebrow}</p> : null}
            <h2 className="insights-featured__title">{title}</h2>
          </div>

          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="insights-featured__cta">
              {cta.text}
              <HiArrowUpRight
                className="insights-featured__cta-icon"
                aria-hidden="true"
              />
            </Link>
          ) : null}
        </Reveal>

        <Reveal className="insights-featured__card" delay={80}>
          <div className="insights-featured__copy">
            {card?.tag ? <p className="insights-featured__tag">{card.tag}</p> : null}
            {card?.title ? <h3 className="insights-featured__card-title">{card.title}</h3> : null}
            {card?.text ? <p className="insights-featured__card-text">{card.text}</p> : null}
            {card?.link?.text && card?.link?.url ? (
              <Link to={card.link.url} className="insights-featured__card-link">
                {card.link.text}
                <HiArrowRight
                  className="insights-featured__card-link-icon"
                  aria-hidden="true"
                />
              </Link>
            ) : null}
          </div>

          <div className="insights-featured__media">
            <img
              className="insights-featured__image"
              src={image || featuredImage}
              alt=""
              aria-hidden="true"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Featured;
